// ════════════════════════════════════════════════════
// MENSCHEN A1.1 — Interactive Exercises (Hueber Arbeitsbuch-enriched)
// 12 Lessons × 3 types × 3 difficulties = 108 exercises
// Enriched with content from the official Arbeitsbuch
// Types: Word Sort, Gap Fill, Dialog Match, Sentence Order
// ════════════════════════════════════════════════════

const EXERCISES = {
  // ──────── LEKTION 1: Hallo! Ich bin Nicole ────────
  L1: {
    title: 'Lektion 1: Hallo! Ich bin Nicole ...',
    worter: {
      leicht: { type: 'sort', instruction: 'Ordnen Sie zu. / Sort the words into categories.',
        categories: ['Begrüßung / Greeting', 'Abschied / Farewell', 'Fragen / Questions'],
        items: [
          { word: 'Hallo', cat: 0 }, { word: 'Guten Morgen', cat: 0 }, { word: 'Guten Tag', cat: 0 },
          { word: 'Guten Abend', cat: 0 }, { word: 'Grüß Gott', cat: 0 },
          { word: 'Auf Wiedersehen', cat: 1 }, { word: 'Tschüss', cat: 1 }, { word: 'Gute Nacht', cat: 1 },
          { word: 'Servus', cat: 1 },
          { word: 'Wie heißen Sie?', cat: 2 }, { word: 'Woher kommen Sie?', cat: 2 },
          { word: 'Wer ist das?', cat: 2 }, { word: 'Wie geht es Ihnen?', cat: 2 },
        ]},
      mittel: { type: 'gap', instruction: 'Ergänzen Sie. / Fill in the blanks.',
        sentences: [
          { text: 'Hallo, ich ___ Nicole.', options: ['bin', 'heiße', 'komme'], answer: 0 },
          { text: 'Wie ___ Sie?', options: ['heißen', 'kommen', 'sind'], answer: 0 },
          { text: 'Ich komme ___ Ägypten.', options: ['von', 'aus', 'in'], answer: 1 },
          { text: 'Guten ___, Herr Müller!', options: ['Morgen', 'Nacht', 'Abend'], answer: 0 },
          { text: '___ geht es Ihnen?', options: ['Wie', 'Was', 'Wer'], answer: 0 },
          { text: 'Mein ___ ist Ahmed.', options: ['Beruf', 'Name', 'Land'], answer: 1 },
          { text: 'Und ___ bist du?', options: ['wer', 'wie', 'wo'], answer: 0 },
          { text: 'Ich ___ aus der Schweiz.', options: ['heiße', 'bin', 'komme'], answer: 2 },
        ]},
      schwer: { type: 'gap', instruction: 'du oder Sie? Ergänzen Sie die richtige Form.',
        sentences: [
          { text: 'Guten Tag, Frau Matard. Woher ___ Sie?', options: ['kommst', 'kommen', 'komme'], answer: 1 },
          { text: 'Hallo. Ich heiß___ Maria. Und wie heißt du?', options: ['-e', '-en', '-t'], answer: 0 },
          { text: 'Kolja, woher ___ du?', options: ['kommen', 'kommst', 'kommt'], answer: 1 },
          { text: 'Frau Klein, woher kommen ___?', options: ['du', 'Sie', 'er'], answer: 1 },
          { text: 'Das ___ Herr Braun. Er kommt aus Berlin.', options: ['bin', 'ist', 'heißt'], answer: 1 },
          { text: '___ Wiedersehen, Frau Müller!', options: ['Auf', 'Guten', 'Wie'], answer: 0 },
        ]},
    },
    strukturen: {
      leicht: { type: 'gap', instruction: 'Konjugation: sein, heißen, kommen — Ergänzen Sie.',
        sentences: [
          { text: 'Ich ___ Nicole. (sein)', options: ['bin', 'bist', 'ist'], answer: 0 },
          { text: 'Du ___ Peter. (sein)', options: ['bin', 'bist', 'ist'], answer: 1 },
          { text: 'Er ___ Arzt. (sein)', options: ['bin', 'bist', 'ist'], answer: 2 },
          { text: 'Ich ___ Maria. (heißen)', options: ['heiße', 'heißt', 'heißen'], answer: 0 },
          { text: 'Sie ___ aus Berlin. (kommen)', options: ['komme', 'kommt', 'kommen'], answer: 1 },
          { text: 'Wir ___ aus Ägypten. (kommen)', options: ['komme', 'kommt', 'kommen'], answer: 2 },
          { text: 'Wie ___ du? (heißen)', options: ['heiße', 'heißt', 'heißen'], answer: 1 },
        ]},
      mittel: { type: 'gap', instruction: 'W-Fragen: Ergänzen Sie wie, woher, wer, wo, was.',
        sentences: [
          { text: '___ heißen Sie? – Ich heiße Anna.', options: ['Wie', 'Wo', 'Was'], answer: 0 },
          { text: '___ kommen Sie? – Aus Syrien.', options: ['Wie', 'Woher', 'Was'], answer: 1 },
          { text: '___ sind Sie von Beruf? – Krankenschwester.', options: ['Wie', 'Woher', 'Was'], answer: 2 },
          { text: '___ wohnen Sie? – In München.', options: ['Woher', 'Was', 'Wo'], answer: 2 },
          { text: '___ ist das? – Das ist Herr Ali.', options: ['Was', 'Wer', 'Wie'], answer: 1 },
          { text: '___ geht es dir? – Gut, danke.', options: ['Was', 'Wer', 'Wie'], answer: 2 },
        ]},
      schwer: { type: 'order', instruction: 'Ordnen Sie den Satz. / Put the sentence in order.',
        sentences: [
          { words: ['Ich', 'heiße', 'Anna', 'Schmidt'], answer: 'Ich heiße Anna Schmidt' },
          { words: ['Woher', 'kommen', 'Sie', '?'], answer: 'Woher kommen Sie?' },
          { words: ['bin', 'Ich', 'Krankenschwester'], answer: 'Ich bin Krankenschwester' },
          { words: ['heißt', 'Wie', 'du', '?'], answer: 'Wie heißt du?' },
          { words: ['komme', 'Ich', 'aus', 'Ägypten'], answer: 'Ich komme aus Ägypten' },
          { words: ['ist', 'Das', 'Frau', 'Wachter'], answer: 'Das ist Frau Wachter' },
        ]},
    },
    kommunikation: {
      leicht: { type: 'match', instruction: 'Ordnen Sie den Dialog zu. / Match the dialog.',
        pairs: [
          { q: 'Guten Tag! Wie heißen Sie?', a: 'Ich heiße Maria Schmidt.' },
          { q: 'Woher kommen Sie?', a: 'Ich komme aus Ägypten.' },
          { q: 'Was sind Sie von Beruf?', a: 'Ich bin Krankenschwester.' },
          { q: 'Wie geht es Ihnen?', a: 'Danke, gut. Und Ihnen?' },
          { q: 'Wer ist das?', a: 'Das ist Herr Müller aus Berlin.' },
        ]},
      mittel: { type: 'gap', instruction: 'Dialog: Ergänzen Sie.',
        sentences: [
          { text: 'A: Guten Tag! Ich bin Herr Müller. Und wie ___ Sie?', options: ['heißen', 'kommen', 'sind'], answer: 0 },
          { text: 'B: Ich ___ Ahmed. Ich komme aus Kairo.', options: ['bin', 'heiße', 'komme'], answer: 1 },
          { text: 'A: Ah, aus ___! Willkommen in Deutschland.', options: ['Kairo', 'Berlin', 'München'], answer: 0 },
          { text: 'B: Danke! Ich ___ jetzt in München.', options: ['komme', 'wohne', 'heiße'], answer: 1 },
          { text: 'A: Wie ___ es dir?', options: ['heißt', 'geht', 'kommt'], answer: 1 },
          { text: 'B: Sehr ___, danke!', options: ['gut', 'nein', 'ja'], answer: 0 },
        ]},
      schwer: { type: 'gap', instruction: 'Wie geht es? Ergänzen Sie die richtige Antwort.',
        sentences: [
          { text: 'Wie geht es Ihnen? – ___, danke.', options: ['Gut', 'Ja', 'Hallo'], answer: 0 },
          { text: 'Wie geht es dir? – Nicht so ___.', options: ['danke', 'gut', 'bitte'], answer: 1 },
          { text: 'Wie geht\'s? – ___ gut, danke.', options: ['Nein', 'Sehr', 'Auch'], answer: 1 },
          { text: 'Und Ihnen? – Es ___.', options: ['heißt', 'kommt', 'geht'], answer: 2 },
          { text: 'Auf ___, Herr Stein!', options: ['Wiedersehen', 'Morgen', 'Nacht'], answer: 0 },
        ]},
    },
  },

  // ──────── LEKTION 2: Ich bin Journalistin ────────
  L2: {
    title: 'Lektion 2: Ich bin Journalistin.',
    worter: {
      leicht: { type: 'sort', instruction: 'Berufe: Maskulin oder Feminin?',
        categories: ['Maskulin (er)', 'Feminin (sie)'],
        items: [
          { word: 'der Arzt', cat: 0 }, { word: 'die Ärztin', cat: 1 },
          { word: 'der Krankenpfleger', cat: 0 }, { word: 'die Krankenschwester', cat: 1 },
          { word: 'der Lehrer', cat: 0 }, { word: 'die Lehrerin', cat: 1 },
          { word: 'der Ingenieur', cat: 0 }, { word: 'die Journalistin', cat: 1 },
          { word: 'der Verkäufer', cat: 0 }, { word: 'die Sekretärin', cat: 1 },
          { word: 'der Schauspieler', cat: 0 }, { word: 'die Friseurin', cat: 1 },
        ]},
      mittel: { type: 'gap', instruction: 'Berufe und Arbeit: Ergänzen Sie.',
        sentences: [
          { text: 'Ich bin ___ von Beruf. (nurse, f)', options: ['Krankenschwester', 'Arzt', 'Lehrerin'], answer: 0 },
          { text: 'Er arbeitet als ___. (doctor)', options: ['Lehrer', 'Arzt', 'Ingenieur'], answer: 1 },
          { text: 'Sie ist ___ an der Universität.', options: ['Studentin', 'Patient', 'Kellner'], answer: 0 },
          { text: 'Mein Bruder ist ___.', options: ['Ärztin', 'Ingenieur', 'Lehrerin'], answer: 1 },
          { text: 'Ich ___ eine Ausbildung als Mechatroniker.', options: ['arbeite', 'mache', 'bin'], answer: 1 },
          { text: 'Sie ___ bei Siemens.', options: ['arbeitet', 'macht', 'ist'], answer: 0 },
          { text: 'Er hat einen ___ als Verkäufer.', options: ['Beruf', 'Job', 'Praktikum'], answer: 1 },
        ]},
      schwer: { type: 'gap', instruction: 'Länder und Sprachen.',
        sentences: [
          { text: 'Ich komme aus Ägypten. Ich spreche ___.', options: ['Arabisch', 'Deutsch', 'Englisch'], answer: 0 },
          { text: 'Sie kommt aus Deutschland. Sie spricht ___.', options: ['Arabisch', 'Deutsch', 'Türkisch'], answer: 1 },
          { text: 'Er kommt aus der Türkei. Er spricht ___.', options: ['Spanisch', 'Deutsch', 'Türkisch'], answer: 2 },
          { text: 'Wir lernen ___ in Deutschland.', options: ['Arabisch', 'Türkisch', 'Deutsch'], answer: 2 },
          { text: 'Sie kommt aus Frankreich. Sie spricht ___.', options: ['Italienisch', 'Französisch', 'Russisch'], answer: 1 },
          { text: 'Er kommt aus Russland. Er spricht ___.', options: ['Russisch', 'Polnisch', 'Spanisch'], answer: 0 },
        ]},
    },
    strukturen: {
      leicht: { type: 'gap', instruction: 'sein / haben: Ergänzen Sie.',
        sentences: [
          { text: 'Ich ___ Journalistin.', options: ['bin', 'habe', 'ist'], answer: 0 },
          { text: 'Er ___ Arzt.', options: ['bin', 'ist', 'sind'], answer: 1 },
          { text: 'Wir ___ Studenten.', options: ['bin', 'ist', 'sind'], answer: 2 },
          { text: 'Sie ___ Lehrerin.', options: ['bin', 'ist', 'sind'], answer: 1 },
          { text: 'Ich ___ zwei Kinder.', options: ['bin', 'ist', 'habe'], answer: 2 },
          { text: 'Er ___ einen Job als Kellner.', options: ['ist', 'hat', 'sind'], answer: 1 },
        ]},
      mittel: { type: 'gap', instruction: 'Negation: nicht / kein',
        sentences: [
          { text: 'Ich bin ___ Arzt. Ich bin Krankenpfleger.', options: ['nicht', 'kein', 'nein'], answer: 1 },
          { text: 'Das ist ___ richtig.', options: ['kein', 'nicht', 'nein'], answer: 1 },
          { text: 'Sie hat ___ Kinder.', options: ['nicht', 'keine', 'nein'], answer: 1 },
          { text: 'Er spricht ___ Deutsch.', options: ['kein', 'nicht', 'nein'], answer: 1 },
          { text: 'Ich habe ___ Job.', options: ['nicht', 'keinen', 'nein'], answer: 1 },
          { text: 'Sie wohnt ___ in München.', options: ['kein', 'nicht', 'nein'], answer: 1 },
        ]},
      schwer: { type: 'order', instruction: 'Satzbau. / Sentence structure.',
        sentences: [
          { words: ['bin', 'Ich', 'von', 'Beruf', 'Journalistin'], answer: 'Ich bin Journalistin von Beruf' },
          { words: ['spricht', 'Sie', 'Deutsch', 'und', 'Arabisch'], answer: 'Sie spricht Deutsch und Arabisch' },
          { words: ['arbeitet', 'Er', 'als', 'Krankenpfleger'], answer: 'Er arbeitet als Krankenpfleger' },
          { words: ['macht', 'Sie', 'eine', 'Ausbildung', 'als', 'Friseurin'], answer: 'Sie macht eine Ausbildung als Friseurin' },
          { words: ['wohnt', 'Er', 'in', 'Dortmund'], answer: 'Er wohnt in Dortmund' },
        ]},
    },
    kommunikation: {
      leicht: { type: 'match', instruction: 'Fragen und Antworten.',
        pairs: [
          { q: 'Was sind Sie von Beruf?', a: 'Ich bin Krankenschwester.' },
          { q: 'Wo arbeiten Sie?', a: 'Im Krankenhaus.' },
          { q: 'Sprechen Sie Deutsch?', a: 'Ja, ein bisschen.' },
          { q: 'Was machen Sie?', a: 'Ich studiere Medizin.' },
          { q: 'Sind Sie verheiratet?', a: 'Nein, ich bin ledig.' },
        ]},
      mittel: { type: 'gap', instruction: 'Vorstellung. / Introduction.',
        sentences: [
          { text: 'A: Was ___ Sie von Beruf?', options: ['sind', 'haben', 'machen'], answer: 0 },
          { text: 'B: Ich bin ___. Ich arbeite im Krankenhaus.', options: ['Lehrerin', 'Krankenschwester', 'Studentin'], answer: 1 },
          { text: 'A: ___ Sie Deutsch?', options: ['Kommen', 'Sprechen', 'Heißen'], answer: 1 },
          { text: 'B: Ja, ich ___ Deutsch und Arabisch.', options: ['komme', 'spreche', 'heiße'], answer: 1 },
          { text: 'A: Wie ___ sind Sie?', options: ['viel', 'alt', 'groß'], answer: 1 },
          { text: 'B: Ich bin 28 ___ alt.', options: ['Monate', 'Jahre', 'Tage'], answer: 1 },
        ]},
      schwer: { type: 'gap', instruction: 'Steckbrief / Profile — Ergänzen Sie.',
        sentences: [
          { text: 'Name: Ahmed. ___ heißt Ahmed.', options: ['Sie', 'Er', 'Ich'], answer: 1 },
          { text: 'Beruf: Krankenpfleger. Er ___ als Krankenpfleger.', options: ['ist', 'arbeitet', 'kommt'], answer: 1 },
          { text: 'Land: Ägypten. Er ___ aus Ägypten.', options: ['wohnt', 'arbeitet', 'kommt'], answer: 2 },
          { text: 'Sprachen: Arabisch, Deutsch. Er ___ Arabisch und Deutsch.', options: ['spricht', 'kommt', 'heißt'], answer: 0 },
          { text: 'Familienstand: ledig. Er ist ___ verheiratet.', options: ['kein', 'nicht', 'nein'], answer: 1 },
        ]},
    },
  },

  // ──────── LEKTION 3: Das ist meine Mutter ────────
  L3: {
    title: 'Lektion 3: Das ist meine Mutter.',
    worter: {
      leicht: { type: 'sort', instruction: 'Familie: Sortieren Sie.',
        categories: ['Männlich / Male', 'Weiblich / Female'],
        items: [
          { word: 'der Vater', cat: 0 }, { word: 'die Mutter', cat: 1 },
          { word: 'der Bruder', cat: 0 }, { word: 'die Schwester', cat: 1 },
          { word: 'der Sohn', cat: 0 }, { word: 'die Tochter', cat: 1 },
          { word: 'der Opa / Großvater', cat: 0 }, { word: 'die Oma / Großmutter', cat: 1 },
          { word: 'der Enkel', cat: 0 }, { word: 'die Enkelin', cat: 1 },
          { word: 'der (Ehe-)Mann', cat: 0 }, { word: 'die (Ehe-)Frau', cat: 1 },
        ]},
      mittel: { type: 'gap', instruction: 'Possessivpronomen: mein/meine.',
        sentences: [
          { text: 'Das ist ___ Mutter. (ich)', options: ['mein', 'meine', 'meinen'], answer: 1 },
          { text: 'Das ist ___ Vater. (ich)', options: ['mein', 'meine', 'meinen'], answer: 0 },
          { text: '___ Schwester heißt Fatima.', options: ['Mein', 'Meine', 'Meinen'], answer: 1 },
          { text: '___ Bruder wohnt in Berlin.', options: ['Mein', 'Meine', 'Meinen'], answer: 0 },
          { text: 'Das sind ___ Eltern.', options: ['mein', 'meine', 'meinen'], answer: 1 },
          { text: 'Das ist ___ Kind.', options: ['mein', 'meine', 'meinen'], answer: 0 },
          { text: '___ Großeltern leben in Österreich.', options: ['Mein', 'Meine', 'Meinen'], answer: 1 },
        ]},
      schwer: { type: 'gap', instruction: 'Familienstand und Sprachen.',
        sentences: [
          { text: 'Ich bin ___. (married)', options: ['ledig', 'verheiratet', 'geschieden'], answer: 1 },
          { text: 'Er ist ___. (single)', options: ['ledig', 'verheiratet', 'verwitwet'], answer: 0 },
          { text: 'Sie hat zwei ___. (children)', options: ['Eltern', 'Geschwister', 'Kinder'], answer: 2 },
          { text: 'Meine ___ sind aus Kairo. (parents)', options: ['Kinder', 'Eltern', 'Geschwister'], answer: 1 },
          { text: 'Wie viele Sprachen ___ du?', options: ['kommst', 'heißt', 'sprichst'], answer: 2 },
          { text: 'Ich spreche Deutsch und ein ___ Englisch.', options: ['groß', 'bisschen', 'viel'], answer: 1 },
        ]},
    },
    strukturen: {
      leicht: { type: 'gap', instruction: 'Possessiv: mein/dein/sein/ihr',
        sentences: [
          { text: 'Er und ___ Frau. (his)', options: ['meine', 'seine', 'ihre'], answer: 1 },
          { text: 'Sie und ___ Mann. (her)', options: ['seine', 'ihr', 'mein'], answer: 1 },
          { text: 'Ich und ___ Kind. (my)', options: ['sein', 'mein', 'ihr'], answer: 1 },
          { text: 'Du und ___ Bruder. (your)', options: ['mein', 'sein', 'dein'], answer: 2 },
          { text: 'Sind das ___ Kinder? (your, formal)', options: ['deine', 'seine', 'Ihre'], answer: 2 },
          { text: '___ Opa lebt in Spanien.', options: ['Mein', 'Meine', 'Meinen'], answer: 0 },
        ]},
      mittel: { type: 'gap', instruction: 'ja / nein / doch — Antworten Sie.',
        sentences: [
          { text: 'Haben Sie Kinder? – Nein, ich habe ___ Kinder.', options: ['nicht', 'keine', 'kein'], answer: 1 },
          { text: 'Sind Sie verheiratet? – Nein, ich bin ___ verheiratet.', options: ['kein', 'keine', 'nicht'], answer: 2 },
          { text: 'Haben Sie Geschwister? – Ja, ich habe ___ Bruder.', options: ['ein', 'einen', 'eine'], answer: 1 },
          { text: 'Du studierst nicht, oder? – ___, ich studiere Physik.', options: ['Ja', 'Nein', 'Doch'], answer: 2 },
          { text: 'Deine Frau heißt nicht Sandra, oder? – ___, sie heißt Sandra.', options: ['Ja', 'Nein', 'Doch'], answer: 2 },
          { text: 'Ist Hannah deine Tochter? – ___, Hannah ist meine Tochter.', options: ['Ja', 'Nein', 'Doch'], answer: 0 },
        ]},
      schwer: { type: 'order', instruction: 'Sätze ordnen.',
        sentences: [
          { words: ['Meine', 'Mutter', 'heißt', 'Fatima'], answer: 'Meine Mutter heißt Fatima' },
          { words: ['hat', 'Er', 'zwei', 'Kinder'], answer: 'Er hat zwei Kinder' },
          { words: ['ist', 'Mein', 'Bruder', 'verheiratet'], answer: 'Mein Bruder ist verheiratet' },
          { words: ['spricht', 'Sie', 'Polnisch', 'Deutsch', 'und', 'Englisch'], answer: 'Sie spricht Polnisch Deutsch und Englisch' },
          { words: ['wohnt', 'Meine', 'Schwester', 'in', 'Berlin'], answer: 'Meine Schwester wohnt in Berlin' },
        ]},
    },
    kommunikation: {
      leicht: { type: 'match', instruction: 'Über die Familie sprechen.',
        pairs: [
          { q: 'Haben Sie Geschwister?', a: 'Ja, ich habe einen Bruder und eine Schwester.' },
          { q: 'Sind Sie verheiratet?', a: 'Ja, meine Frau heißt Sara.' },
          { q: 'Haben Sie Kinder?', a: 'Ja, zwei Söhne und eine Tochter.' },
          { q: 'Wo wohnen Ihre Eltern?', a: 'In Kairo, Ägypten.' },
          { q: 'Welche Sprachen sprichst du?', a: 'Deutsch, Arabisch und ein bisschen Englisch.' },
        ]},
      mittel: { type: 'gap', instruction: 'Familie vorstellen.',
        sentences: [
          { text: 'Das ist mein ___. Er heißt Omar.', options: ['Schwester', 'Bruder', 'Mutter'], answer: 1 },
          { text: 'Meine ___ wohnt in Alexandria.', options: ['Bruder', 'Vater', 'Schwester'], answer: 2 },
          { text: 'Meine Eltern ___ aus Ägypten.', options: ['kommt', 'kommen', 'komme'], answer: 1 },
          { text: 'Mein Opa ___ in Spanien.', options: ['lebt', 'leben', 'lebst'], answer: 0 },
          { text: 'Sie haben zwei ___: Ali und Sara.', options: ['Eltern', 'Kinder', 'Geschwister'], answer: 1 },
        ]},
      schwer: { type: 'gap', instruction: 'Steckbrief: Familie.',
        sentences: [
          { text: 'Ahmed ist ___. Seine Frau heißt Fatima.', options: ['ledig', 'verheiratet', 'geschieden'], answer: 1 },
          { text: 'Sie haben ___ Kinder: Ali und Sara.', options: ['drei', 'zwei', 'vier'], answer: 1 },
          { text: 'Ahmeds ___ wohnen in Kairo.', options: ['Kinder', 'Eltern', 'Freunde'], answer: 1 },
          { text: 'Seine Schwester ___ Medizin.', options: ['arbeitet', 'studiert', 'lebt'], answer: 1 },
          { text: 'Sein Vater ist ___ von Beruf.', options: ['Studentin', 'Journalist', 'Lehrerin'], answer: 1 },
        ]},
    },
  },

  // ──────── LEKTION 4: Der Tisch ist schön! ────────
  L4: {
    title: 'Lektion 4: Der Tisch ist schön!',
    worter: {
      leicht: { type: 'sort', instruction: 'Möbel: Welcher Artikel? der/die/das',
        categories: ['der (maskulin)', 'die (feminin)', 'das (neutral)'],
        items: [
          { word: 'Tisch', cat: 0 }, { word: 'Stuhl', cat: 0 }, { word: 'Schrank', cat: 0 },
          { word: 'Sessel', cat: 0 }, { word: 'Teppich', cat: 0 },
          { word: 'Lampe', cat: 1 }, { word: 'Couch', cat: 1 },
          { word: 'Bett', cat: 2 }, { word: 'Sofa', cat: 2 }, { word: 'Regal', cat: 2 },
          { word: 'Bild', cat: 2 },
        ]},
      mittel: { type: 'gap', instruction: 'Adjektive und Preise: Ergänzen Sie.',
        sentences: [
          { text: 'Der Tisch ist ___. (beautiful)', options: ['hässlich', 'schön', 'billig'], answer: 1 },
          { text: 'Die Lampe ist zu ___. (expensive)', options: ['billig', 'groß', 'teuer'], answer: 2 },
          { text: 'Das Sofa ist sehr ___. (comfortable)', options: ['bequem', 'alt', 'klein'], answer: 0 },
          { text: 'Der Schrank ist ___. (modern)', options: ['alt', 'modern', 'hässlich'], answer: 1 },
          { text: 'Der Stuhl ist zu ___. (small)', options: ['groß', 'leicht', 'klein'], answer: 2 },
          { text: 'Das Bett kostet 500 ___. (euros)', options: ['Dollar', 'Euro', 'Pfund'], answer: 1 },
          { text: 'Die Couch ist wirklich ___. (cheap)', options: ['teuer', 'günstig', 'schwer'], answer: 1 },
        ]},
      schwer: { type: 'gap', instruction: 'Gegensätze (Opposites) — Ergänzen Sie.',
        sentences: [
          { text: 'groß – ___', options: ['lang', 'klein', 'kurz'], answer: 1 },
          { text: 'schön – ___', options: ['hässlich', 'modern', 'billig'], answer: 0 },
          { text: 'billig – ___', options: ['günstig', 'teuer', 'leicht'], answer: 1 },
          { text: 'kurz – ___', options: ['klein', 'schwer', 'lang'], answer: 2 },
          { text: 'leicht – ___', options: ['praktisch', 'schwer', 'modern'], answer: 1 },
        ]},
    },
    strukturen: {
      leicht: { type: 'gap', instruction: 'Bestimmter Artikel: der/die/das',
        sentences: [
          { text: '___ Tisch ist groß.', options: ['Der', 'Die', 'Das'], answer: 0 },
          { text: '___ Lampe ist neu.', options: ['Der', 'Die', 'Das'], answer: 1 },
          { text: '___ Bett ist bequem.', options: ['Der', 'Die', 'Das'], answer: 2 },
          { text: '___ Küche ist klein.', options: ['Der', 'Die', 'Das'], answer: 1 },
          { text: '___ Schrank kostet 799 Euro.', options: ['Der', 'Die', 'Das'], answer: 0 },
          { text: '___ Sofa ist nicht schlecht.', options: ['Der', 'Die', 'Das'], answer: 2 },
        ]},
      mittel: { type: 'gap', instruction: 'Personalpronomen er/sie/es — Was passt?',
        sentences: [
          { text: 'Der Schrank ist billig. ___ kostet nur 79,99 Euro.', options: ['Er', 'Sie', 'Es'], answer: 0 },
          { text: 'Die Lampe ist schön. ___ kommt aus Italien.', options: ['Er', 'Sie', 'Es'], answer: 1 },
          { text: 'Das Bett ist sehr modern. ___ ist aber sehr klein.', options: ['Er', 'Sie', 'Es'], answer: 2 },
          { text: 'Die Couch ist wirklich schön. Was kostet ___?', options: ['er', 'sie', 'es'], answer: 1 },
          { text: 'Der Teppich kommt aus Marokko. ___ ist sehr groß.', options: ['Er', 'Sie', 'Es'], answer: 0 },
        ]},
      schwer: { type: 'order', instruction: 'Sätze ordnen.',
        sentences: [
          { words: ['kostet', 'Was', 'der', 'Tisch', '?'], answer: 'Was kostet der Tisch?' },
          { words: ['schön', 'Die', 'ist', 'Lampe'], answer: 'Die Lampe ist schön' },
          { words: ['brauche', 'Ich', 'Bett', 'ein'], answer: 'Ich brauche ein Bett' },
          { words: ['ist', 'Der', 'Stuhl', 'zu', 'teuer'], answer: 'Der Stuhl ist zu teuer' },
          { words: ['das', 'Ist', 'ein', 'Sonderangebot', '?'], answer: 'Ist das ein Sonderangebot?' },
        ]},
    },
    kommunikation: {
      leicht: { type: 'match', instruction: 'Im Möbelgeschäft.',
        pairs: [
          { q: 'Was kostet der Tisch?', a: 'Der Tisch kostet 200 Euro.' },
          { q: 'Ist der Stuhl bequem?', a: 'Ja, sehr bequem!' },
          { q: 'Gefällt Ihnen die Lampe?', a: 'Ja, die ist schön.' },
          { q: 'Brauchen Sie ein Bett?', a: 'Ja, ein großes Bett, bitte.' },
          { q: 'Brauchen Sie Hilfe?', a: 'Ja, bitte. Was kostet das Sofa?' },
        ]},
      mittel: { type: 'gap', instruction: 'Einkaufsdialog.',
        sentences: [
          { text: 'A: Guten Tag, ___ Sie Hilfe?', options: ['haben', 'brauchen', 'finden'], answer: 1 },
          { text: 'B: Ja, bitte. Was ___ der Tisch?', options: ['ist', 'kostet', 'hat'], answer: 1 },
          { text: 'A: Er kostet 350 ___.', options: ['Dollar', 'Euro', 'Stück'], answer: 1 },
          { text: 'B: Das ist zu ___!', options: ['billig', 'schön', 'teuer'], answer: 2 },
          { text: 'A: Wir haben auch ___ Tische. Das ist ein Sonderangebot.', options: ['teure', 'günstige', 'große'], answer: 1 },
        ]},
      schwer: { type: 'gap', instruction: 'Wohnungsbeschreibung.',
        sentences: [
          { text: 'Meine Wohnung hat ___ Zimmer.', options: ['drei', 'der', 'ein'], answer: 0 },
          { text: 'Die ___ ist klein aber modern.', options: ['Schlafzimmer', 'Küche', 'Bad'], answer: 1 },
          { text: 'Im Wohnzimmer steht ein neues ___.', options: ['Lampe', 'Sofa', 'Tisch'], answer: 1 },
          { text: 'Der Teppich ___ aus Marokko.', options: ['ist', 'kommt', 'hat'], answer: 1 },
          { text: 'Vielen Dank für die ___!', options: ['Hilfe', 'Möbel', 'Zimmer'], answer: 0 },
        ]},
    },
  },

  // ──────── LEKTION 5: Was ist das? – Das ist ein F. ────────
  L5: {
    title: 'Lektion 5: Was ist das? – Das ist ein F.',
    worter: {
      leicht: { type: 'sort', instruction: 'Gegenstände und Materialien.',
        categories: ['Gegenstände / Objects', 'Materialien / Materials'],
        items: [
          { word: 'der Schlüssel', cat: 0 }, { word: 'die Brille', cat: 0 }, { word: 'das Feuerzeug', cat: 0 },
          { word: 'die Kette', cat: 0 }, { word: 'der Fotoapparat', cat: 0 }, { word: 'die Flasche', cat: 0 },
          { word: 'Metall', cat: 1 }, { word: 'Plastik', cat: 1 }, { word: 'Glas', cat: 1 },
          { word: 'Holz', cat: 1 }, { word: 'Papier', cat: 1 },
        ]},
      mittel: { type: 'gap', instruction: 'Farben und Formen.',
        sentences: [
          { text: 'Der Stuhl ist ___. (red)', options: ['blau', 'rot', 'grün'], answer: 1 },
          { text: 'Die Lampe ist ___. (white)', options: ['schwarz', 'gelb', 'weiß'], answer: 2 },
          { text: 'Das Feuerzeug ist aus ___. (plastic)', options: ['Holz', 'Metall', 'Plastik'], answer: 2 },
          { text: 'Die Flasche ist aus ___. (glass)', options: ['Glas', 'Papier', 'Plastik'], answer: 0 },
          { text: 'Der Schlüssel ist aus ___. (metal)', options: ['Holz', 'Metall', 'Papier'], answer: 1 },
          { text: 'Das Buch ist aus ___. (paper)', options: ['Glas', 'Papier', 'Metall'], answer: 1 },
        ]},
      schwer: { type: 'gap', instruction: 'Formulare: Was passt?',
        sentences: [
          { text: 'Paul Paulsen → Das ist der ___.', options: ['Vorname', 'Familienname', 'Wohnort'], answer: 1 },
          { text: '6020 Innsbruck → Das ist der ___.', options: ['Beruf', 'Ort mit PLZ', 'Familienname'], answer: 1 },
          { text: 'Diplom-Ingenieur → Das ist der ___.', options: ['Wohnort', 'Name', 'Beruf'], answer: 2 },
          { text: 'paul@paul.at → Das ist die ___.', options: ['Straße', 'E-Mail', 'Telefonnummer'], answer: 1 },
          { text: 'Resseltstr. 15 → Das ist die ___.', options: ['Straße', 'PLZ', 'E-Mail'], answer: 0 },
        ]},
    },
    strukturen: {
      leicht: { type: 'gap', instruction: 'ein/eine/kein/keine',
        sentences: [
          { text: 'Das ist ___ Drucker.', options: ['ein', 'eine', 'einen'], answer: 0 },
          { text: 'Das ist ___ Tastatur.', options: ['ein', 'eine', 'einen'], answer: 1 },
          { text: 'Ich habe ___ Computer. (no)', options: ['kein', 'keine', 'keinen'], answer: 2 },
          { text: 'Das ist ___ Handy. Das ist ein Telefon.', options: ['kein', 'keine', 'keinen'], answer: 0 },
          { text: 'Das ist ___ Flasche.', options: ['kein', 'keine', 'keinen'], answer: 1 },
          { text: 'Bitte, das ist ___ Problem.', options: ['kein', 'keine', 'keinen'], answer: 0 },
        ]},
      mittel: { type: 'gap', instruction: 'nicht oder kein-? Was passt?',
        sentences: [
          { text: 'Das ist ___ schwer.', options: ['nicht', 'kein', 'keine'], answer: 0 },
          { text: 'Ich habe ___ Kinder.', options: ['nicht', 'keine', 'kein'], answer: 1 },
          { text: 'Ich finde das Sofa ___ schön.', options: ['kein', 'nicht', 'keine'], answer: 1 },
          { text: 'Ich lebe ___ in Deutschland.', options: ['kein', 'nicht', 'keine'], answer: 1 },
          { text: 'Das ist ___ richtig.', options: ['kein', 'nicht', 'keine'], answer: 1 },
          { text: 'Ich bin ___ verheiratet.', options: ['kein', 'nicht', 'keine'], answer: 1 },
        ]},
      schwer: { type: 'order', instruction: 'Sätze ordnen.',
        sentences: [
          { words: ['einen', 'Ich', 'brauche', 'Computer'], answer: 'Ich brauche einen Computer' },
          { words: ['kein', 'Ich', 'habe', 'Handy'], answer: 'Ich habe kein Handy' },
          { words: ['eine', 'Das', 'Tastatur', 'ist'], answer: 'Das ist eine Tastatur' },
          { words: ['Wie', 'man', 'schreibt', 'das', '?'], answer: 'Wie schreibt man das?' },
          { words: ['heißt', 'Wie', 'das', 'auf', 'Deutsch', '?'], answer: 'Wie heißt das auf Deutsch?' },
        ]},
    },
    kommunikation: {
      leicht: { type: 'match', instruction: 'Im Büro / Alltag.',
        pairs: [
          { q: 'Was ist das?', a: 'Das ist ein Drucker.' },
          { q: 'Funktioniert der Computer?', a: 'Nein, er ist kaputt.' },
          { q: 'Haben Sie einen Kugelschreiber?', a: 'Ja, hier bitte.' },
          { q: 'Wie heißt das auf Deutsch?', a: 'Das ist eine Zeitung.' },
          { q: 'Wie schreibt man das?', a: 'Z-E-I-T-U-N-G.' },
        ]},
      mittel: { type: 'gap', instruction: 'Im Geschäft.',
        sentences: [
          { text: 'A: Entschuldigung, haben Sie ___ Kugelschreiber?', options: ['ein', 'eine', 'einen'], answer: 2 },
          { text: 'B: Ja, ___! Hier bitte.', options: ['danke', 'bitte', 'natürlich'], answer: 2 },
          { text: 'A: Und wie ist das ___-Passwort?', options: ['WLAN', 'Computer', 'Drucker'], answer: 0 },
          { text: 'B: Bitteschön, ___ Problem.', options: ['ein', 'kein', 'nicht'], answer: 1 },
        ]},
      schwer: { type: 'gap', instruction: 'E-Mail schreiben.',
        sentences: [
          { text: '___ Frau Müller, (Dear)', options: ['Liebe', 'Hallo', 'Guten'], answer: 0 },
          { text: 'ich brauche bitte ___ neuen Computer.', options: ['ein', 'eine', 'einen'], answer: 2 },
          { text: 'Mit freundlichen ___', options: ['Grüßen', 'Dank', 'Wünschen'], answer: 0 },
          { text: 'Vielen ___ für Ihre Hilfe.', options: ['Grüße', 'Dank', 'Bitte'], answer: 1 },
        ]},
    },
  },

  // ──────── LEKTION 6: Ich brauche kein Büro ────────
  L6: { title: 'Lektion 6: Ich brauche kein Büro.', worter: { leicht: { type: 'gap', instruction: 'Zimmer und Räume.',
    sentences: [
      { text: 'Ich schlafe im ___. (bedroom)', options: ['Wohnzimmer', 'Schlafzimmer', 'Badezimmer'], answer: 1 },
      { text: 'Ich koche in der ___. (kitchen)', options: ['Küche', 'Garage', 'Balkon'], answer: 0 },
      { text: 'Ich dusche im ___. (bathroom)', options: ['Schlafzimmer', 'Flur', 'Badezimmer'], answer: 2 },
      { text: 'Wir essen im ___. (living room)', options: ['Bad', 'Wohnzimmer', 'Flur'], answer: 1 },
      { text: 'Das Auto steht in der ___.', options: ['Küche', 'Garage', 'Wohnung'], answer: 1 },
    ]}, mittel: { type: 'gap', instruction: 'Wohnung beschreiben.', sentences: [
      { text: 'Die Wohnung hat 3 ___. (rooms)', options: ['Küchen', 'Zimmer', 'Bäder'], answer: 1 },
      { text: 'Die Miete ist 800 Euro ___.', options: ['warm', 'kalt', 'billig'], answer: 0 },
      { text: 'Die Wohnung ist sehr ___. (bright)', options: ['dunkel', 'hell', 'klein'], answer: 1 },
      { text: 'Die Wohnung ist 65 ___ groß.', options: ['Euro', 'qm', 'Zimmer'], answer: 1 },
      { text: 'Miete: 750€ ___ + Nebenkosten.', options: ['kalt', 'warm', 'mit'], answer: 0 },
    ]}, schwer: { type: 'gap', instruction: 'Wohnungsanzeige.', sentences: [
      { text: '2-Zimmer-Wohnung, 65 qm, ab ___.', options: ['morgen', 'sofort', 'gestern'], answer: 1 },
      { text: 'Kontakt: Bitte per ___ anrufen.', options: ['E-Mail', 'Telefon', 'Brief'], answer: 1 },
      { text: 'Die Wohnung hat einen ___ und einen Keller.', options: ['Balkon', 'Beruf', 'Kurs'], answer: 0 },
      { text: 'Die ___ beträgt 750 Euro.', options: ['Wohnung', 'Miete', 'Küche'], answer: 1 },
    ]}}, strukturen: { leicht: { type: 'gap', instruction: 'Negation mit kein-.',
    sentences: [
      { text: 'Ich brauche ___ Büro.', options: ['kein', 'keine', 'keinen'], answer: 0 },
      { text: 'Wir haben ___ Balkon.', options: ['kein', 'keine', 'keinen'], answer: 2 },
      { text: 'Die Wohnung hat ___ Garage.', options: ['kein', 'keine', 'keinen'], answer: 1 },
      { text: 'Ich habe ___ Geld.', options: ['kein', 'keine', 'keinen'], answer: 0 },
      { text: 'Das ist ___ Problem.', options: ['kein', 'keine', 'keinen'], answer: 0 },
    ]}, mittel: { type: 'gap', instruction: 'Präpositionen: in/an/auf', sentences: [
      { text: 'Die Lampe steht ___ dem Tisch.', options: ['in', 'auf', 'an'], answer: 1 },
      { text: 'Das Bild hängt ___ der Wand.', options: ['in', 'auf', 'an'], answer: 2 },
      { text: 'Das Buch ist ___ dem Regal.', options: ['in', 'auf', 'an'], answer: 0 },
      { text: 'Der Stuhl steht ___ dem Fenster.', options: ['in', 'auf', 'an'], answer: 2 },
      { text: 'Ich wohne ___ München.', options: ['in', 'auf', 'an'], answer: 0 },
    ]}, schwer: { type: 'order', instruction: 'Wohnungsbeschreibung ordnen.', sentences: [
      { words: ['Die', 'Wohnung', 'hat', 'zwei', 'Zimmer'], answer: 'Die Wohnung hat zwei Zimmer' },
      { words: ['brauche', 'Ich', 'kein', 'Büro'], answer: 'Ich brauche kein Büro' },
      { words: ['steht', 'Die', 'Lampe', 'auf', 'dem', 'Tisch'], answer: 'Die Lampe steht auf dem Tisch' },
      { words: ['hängt', 'Das', 'Bild', 'an', 'der', 'Wand'], answer: 'Das Bild hängt an der Wand' },
    ]}}, kommunikation: { leicht: { type: 'match', instruction: 'Wohnung suchen.', pairs: [
      { q: 'Wie groß ist die Wohnung?', a: '65 Quadratmeter.' },
      { q: 'Wie viel kostet die Miete?', a: '750 Euro kalt.' },
      { q: 'Hat die Wohnung einen Balkon?', a: 'Ja, einen kleinen Balkon.' },
      { q: 'Wie viele Zimmer hat die Wohnung?', a: 'Drei Zimmer, Küche und Bad.' },
      { q: 'Ab wann ist die Wohnung frei?', a: 'Ab sofort.' },
    ]}, mittel: { type: 'gap', instruction: 'Wohnungsgespräch.', sentences: [
      { text: 'A: Wie ___ ist die Wohnung?', options: ['viel', 'groß', 'alt'], answer: 1 },
      { text: 'B: 65 Quadratmeter mit ___ Zimmern.', options: ['zwei', 'der', 'ein'], answer: 0 },
      { text: 'A: Was kostet die ___?', options: ['Wohnung', 'Miete', 'Zimmer'], answer: 1 },
      { text: 'B: 750 Euro ___ plus Nebenkosten.', options: ['warm', 'kalt', 'groß'], answer: 1 },
    ]}, schwer: { type: 'gap', instruction: 'Umzug / Moving.', sentences: [
      { text: 'Ich ___ nächste Woche um.', options: ['fahre', 'ziehe', 'komme'], answer: 1 },
      { text: 'Kannst du mir beim ___ helfen?', options: ['Kochen', 'Umzug', 'Einkaufen'], answer: 1 },
      { text: 'Wir brauchen noch ___ für das Schlafzimmer.', options: ['Möbel', 'Essen', 'Geld'], answer: 0 },
    ]}}},

  // ──────── LEKTION 7: Du kannst wirklich toll ...! ────────
  L7: { title: 'Lektion 7: Du kannst wirklich toll ...!', worter: { leicht: { type: 'sort', instruction: 'Hobbys und Freizeit sortieren.', categories: ['Sport', 'Kultur / Zu Hause'], items: [
    { word: 'Fußball spielen', cat: 0 }, { word: 'schwimmen', cat: 0 }, { word: 'joggen', cat: 0 },
    { word: 'Rad fahren', cat: 0 }, { word: 'Tennis spielen', cat: 0 }, { word: 'Ski fahren', cat: 0 },
    { word: 'Musik hören', cat: 1 }, { word: 'lesen', cat: 1 }, { word: 'kochen', cat: 1 },
    { word: 'ins Kino gehen', cat: 1 }, { word: 'fotografieren', cat: 1 }, { word: 'malen', cat: 1 },
  ]}, mittel: { type: 'gap', instruction: 'Modalverb: können — Ergänzen Sie.', sentences: [
    { text: 'Ich ___ gut kochen.', options: ['kann', 'kannst', 'können'], answer: 0 },
    { text: 'Du ___ toll singen!', options: ['kann', 'kannst', 'können'], answer: 1 },
    { text: 'Er ___ nicht schwimmen.', options: ['kann', 'kannst', 'können'], answer: 0 },
    { text: 'Wir ___ am Samstag kommen.', options: ['kann', 'könnt', 'können'], answer: 2 },
    { text: '___ ihr Schach spielen?', options: ['Kann', 'Könnt', 'Können'], answer: 1 },
    { text: 'Meine Schwester ___ sehr gut malen.', options: ['kann', 'kannst', 'können'], answer: 0 },
  ]}, schwer: { type: 'gap', instruction: 'Wie oft? — Häufigkeitswörter.', sentences: [
    { text: 'Ich gehe ___ ins Kino. (100%)', options: ['nie', 'manchmal', 'immer'], answer: 2 },
    { text: 'Er spielt ___ Fußball. (0%)', options: ['nie', 'oft', 'immer'], answer: 0 },
    { text: 'Wir kochen ___ zusammen. (sometimes)', options: ['nie', 'manchmal', 'immer'], answer: 1 },
    { text: 'Sie geht ___ spazieren. (often)', options: ['nie', 'oft', 'manchmal'], answer: 1 },
    { text: 'Ich surfe ___ im Internet. (almost never)', options: ['fast nie', 'immer', 'oft'], answer: 0 },
  ]}}, strukturen: { leicht: { type: 'gap', instruction: 'können / müssen — Ergänzen Sie.', sentences: [
    { text: 'Ich ___ heute nicht kommen. (can)', options: ['muss', 'kann', 'will'], answer: 1 },
    { text: 'Du ___ morgen arbeiten. (must)', options: ['musst', 'kannst', 'willst'], answer: 0 },
    { text: 'Er ___ gut Deutsch sprechen.', options: ['muss', 'kann', 'soll'], answer: 1 },
    { text: 'Wir ___ Fußball spielen.', options: ['kann', 'könnt', 'können'], answer: 2 },
    { text: '___ du morgen kommen?', options: ['Kann', 'Kannst', 'Können'], answer: 1 },
  ]}, mittel: { type: 'gap', instruction: 'Satzklammer: Modalverb + Infinitiv', sentences: [
    { text: 'Ich kann gut Fußball ___.', options: ['spiele', 'spielen', 'spielt'], answer: 1 },
    { text: 'Kannst du morgen ___?', options: ['komme', 'kommst', 'kommen'], answer: 2 },
    { text: 'Wir müssen heute ___.', options: ['arbeiten', 'arbeite', 'arbeitet'], answer: 0 },
    { text: 'Können wir ein bisschen Musik ___?', options: ['hören', 'höre', 'hört'], answer: 0 },
    { text: 'Er kann wirklich toll ___.', options: ['koche', 'kochen', 'kocht'], answer: 1 },
  ]}, schwer: { type: 'order', instruction: 'Modalverb-Sätze ordnen.', sentences: [
    { words: ['kann', 'Ich', 'gut', 'kochen'], answer: 'Ich kann gut kochen' },
    { words: ['du', 'Kannst', 'schwimmen', '?'], answer: 'Kannst du schwimmen?' },
    { words: ['können', 'Wir', 'Fußball', 'spielen'], answer: 'Wir können Fußball spielen' },
    { words: ['kann', 'Er', 'toll', 'wirklich', 'singen'], answer: 'Er kann wirklich toll singen' },
  ]}}, kommunikation: { leicht: { type: 'match', instruction: 'Über Hobbys und Freizeit sprechen.', pairs: [
    { q: 'Was machst du gern?', a: 'Ich koche gern.' },
    { q: 'Kannst du schwimmen?', a: 'Ja, ich schwimme gern.' },
    { q: 'Spielst du Fußball?', a: 'Nein, aber ich jogge gern.' },
    { q: 'Was sind deine Hobbys?', a: 'Musik hören und Rad fahren.' },
    { q: 'Kann ich mal dein Buch haben?', a: 'Ja, natürlich! Hier bitte.' },
  ]}, mittel: { type: 'gap', instruction: 'Verabredung / Making plans.', sentences: [
    { text: 'A: Hast du am Samstag ___?', options: ['Geld', 'Zeit', 'Hunger'], answer: 1 },
    { text: 'B: Ja, was möchtest du ___?', options: ['essen', 'machen', 'kaufen'], answer: 1 },
    { text: 'A: Wir können ins ___ gehen.', options: ['Büro', 'Kino', 'Krankenhaus'], answer: 1 },
    { text: 'B: ___, gern!', options: ['Nein', 'Ja', 'Leider'], answer: 1 },
    { text: 'A: Das macht bestimmt ___!', options: ['Geld', 'Spaß', 'Arbeit'], answer: 1 },
  ]}, schwer: { type: 'gap', instruction: 'Bitten und reagieren.', sentences: [
    { text: 'Kann ich bitte dein Handy ___?', options: ['kaufen', 'haben', 'sehen'], answer: 1 },
    { text: 'Ja, ___! Hier bitte.', options: ['leider', 'natürlich', 'nein'], answer: 1 },
    { text: 'Tut mir ___, das geht leider nicht.', options: ['gut', 'leid', 'weh'], answer: 1 },
    { text: '___ Dank! Das ist sehr nett.', options: ['Vielen', 'Guten', 'Herzlich'], answer: 0 },
  ]}}},

  // ──────── LEKTION 8: Kein Problem. Ich habe Zeit! ────────
  L8: { title: 'Lektion 8: Kein Problem. Ich habe Zeit!', worter: { leicht: { type: 'sort', instruction: 'Orte in der Stadt sortieren.', categories: ['Kultur / Entertainment', 'Essen & Trinken'], items: [
    { word: 'das Kino', cat: 0 }, { word: 'das Theater', cat: 0 }, { word: 'das Museum', cat: 0 },
    { word: 'das Konzert', cat: 0 }, { word: 'die Disco', cat: 0 },
    { word: 'das Restaurant', cat: 1 }, { word: 'das Café', cat: 1 }, { word: 'die Bar', cat: 1 },
    { word: 'die Kneipe', cat: 1 }, { word: 'das Schwimmbad', cat: 0 },
  ]}, mittel: { type: 'gap', instruction: 'Uhrzeit — Wie spät ist es?', sentences: [
    { text: 'Es ist acht ___. (8:00)', options: ['Uhr', 'Stunde', 'Minuten'], answer: 0 },
    { text: 'Der Termin ist um ___ drei. (2:30)', options: ['halb', 'Viertel', 'zehn nach'], answer: 0 },
    { text: 'Es ist Viertel ___ drei. (2:15)', options: ['vor', 'nach', 'um'], answer: 1 },
    { text: 'Es ist fünf ___ zehn. (9:55)', options: ['nach', 'vor', 'um'], answer: 1 },
    { text: 'Es ist Viertel ___ acht. (7:45)', options: ['nach', 'um', 'vor'], answer: 2 },
  ]}, schwer: { type: 'gap', instruction: 'Wochentage und Tageszeiten.', sentences: [
    { text: 'Am ___ frühstücke ich. (morning)', options: ['Abend', 'Morgen', 'Mittag'], answer: 1 },
    { text: 'Am ___ esse ich zu Mittag.', options: ['Morgen', 'Mittag', 'Abend'], answer: 1 },
    { text: 'Am ___ gehe ich ins Bett.', options: ['Morgen', 'Nachmittag', 'Abend'], answer: 2 },
    { text: 'Die Woche hat sieben ___: Montag bis Sonntag.', options: ['Monate', 'Tage', 'Stunden'], answer: 1 },
    { text: 'Ich habe einen ___ beim Arzt.', options: ['Termin', 'Kurs', 'Beruf'], answer: 0 },
  ]}}, strukturen: { leicht: { type: 'gap', instruction: 'Trennbare Verben.', sentences: [
    { text: 'Ich stehe um 6 Uhr ___. (aufstehen)', options: ['an', 'auf', 'ein'], answer: 1 },
    { text: 'Der Kurs fängt um 9 Uhr ___. (anfangen)', options: ['an', 'auf', 'ab'], answer: 0 },
    { text: 'Ich kaufe heute ___. (einkaufen)', options: ['an', 'auf', 'ein'], answer: 2 },
    { text: 'Abends sehe ich ___. (fernsehen)', options: ['an', 'fern', 'ab'], answer: 1 },
    { text: 'Ich rufe dich morgen ___. (anrufen)', options: ['an', 'ab', 'ein'], answer: 0 },
  ]}, mittel: { type: 'gap', instruction: 'Temporale Präpositionen: um/am/von...bis.', sentences: [
    { text: 'Ich arbeite ___ 8 bis 16 Uhr.', options: ['um', 'von', 'am'], answer: 1 },
    { text: 'Der Termin ist ___ Montag.', options: ['um', 'von', 'am'], answer: 2 },
    { text: 'Der Film beginnt ___ 20 Uhr.', options: ['um', 'von', 'am'], answer: 0 },
    { text: '___ Wochenende habe ich Zeit.', options: ['Um', 'Von', 'Am'], answer: 2 },
    { text: 'Der Deutschkurs ist ___ Montag ___ Freitag.', options: ['am...am', 'von...bis', 'um...um'], answer: 1 },
  ]}, schwer: { type: 'order', instruction: 'Tagesablauf ordnen.', sentences: [
    { words: ['stehe', 'Ich', 'um', '6 Uhr', 'auf'], answer: 'Ich stehe um 6 Uhr auf' },
    { words: ['fängt', 'Der', 'Kurs', 'um 9', 'an'], answer: 'Der Kurs fängt um 9 an' },
    { words: ['Samstag', 'Am', 'gehe', 'ich', 'ins', 'Kino'], answer: 'Am Samstag gehe ich ins Kino' },
    { words: ['kaufe', 'Ich', 'heute', 'Nachmittag', 'ein'], answer: 'Ich kaufe heute Nachmittag ein' },
  ]}}, kommunikation: { leicht: { type: 'match', instruction: 'Verabredung und Termine.', pairs: [
    { q: 'Haben Sie am Montag Zeit?', a: 'Ja, am Vormittag.' },
    { q: 'Wann beginnt der Kurs?', a: 'Um 9 Uhr.' },
    { q: 'Wie lange dauert der Termin?', a: 'Etwa eine Stunde.' },
    { q: 'Gehen wir ins Kino?', a: 'Ja, gern! Wann denn?' },
    { q: 'Sag mal, was machst du am Freitag?', a: 'Das weiß ich noch nicht.' },
  ]}, mittel: { type: 'gap', instruction: 'Vorschlag machen und reagieren.', sentences: [
    { text: 'A: ___ ich einen Termin machen?', options: ['Kann', 'Muss', 'Will'], answer: 0 },
    { text: 'B: Ja, ___ passt es Ihnen?', options: ['wie', 'wann', 'wo'], answer: 1 },
    { text: 'A: Fährst du mit mir ___? Hast du Lust?', options: ['Rad', 'Auto', 'Bus'], answer: 0 },
    { text: 'B: Hm, ja, warum ___?', options: ['ja', 'nein', 'nicht'], answer: 2 },
    { text: 'A: Treffen wir uns ___ vier Uhr?', options: ['am', 'von', 'um'], answer: 2 },
  ]}, schwer: { type: 'gap', instruction: 'Termin absagen.', sentences: [
    { text: 'Ich muss den Termin leider ___.', options: ['machen', 'absagen', 'beginnen'], answer: 1 },
    { text: 'Können wir einen ___ Termin machen?', options: ['alten', 'neuen', 'großen'], answer: 1 },
    { text: 'Da kann ich ___ nicht.', options: ['gern', 'leider', 'natürlich'], answer: 1 },
    { text: 'Tut mir leid, ich habe keine ___.', options: ['Lust', 'Geld', 'Zeit'], answer: 2 },
  ]}}},

  // ──────── LEKTION 9: Ich möchte was essen ────────
  L9: { title: 'Lektion 9: Ich möchte was essen.', worter: { leicht: { type: 'sort', instruction: 'Essen und Trinken sortieren.', categories: ['Essen / Food', 'Trinken / Drinks'], items: [
    { word: 'Brot', cat: 0 }, { word: 'Käse', cat: 0 }, { word: 'Kartoffeln', cat: 0 }, { word: 'Fleisch', cat: 0 },
    { word: 'Ei', cat: 0 }, { word: 'Wurst', cat: 0 }, { word: 'Kuchen', cat: 0 },
    { word: 'Kaffee', cat: 1 }, { word: 'Tee', cat: 1 }, { word: 'Wasser', cat: 1 },
    { word: 'Saft', cat: 1 }, { word: 'Milch', cat: 1 },
  ]}, mittel: { type: 'gap', instruction: 'Im Restaurant bestellen.', sentences: [
    { text: 'Ich hätte gern einen ___. (coffee)', options: ['Tee', 'Kaffee', 'Saft'], answer: 1 },
    { text: 'Die ___, bitte. (bill)', options: ['Speisekarte', 'Rechnung', 'Bestellung'], answer: 1 },
    { text: 'Ich möchte ___ bestellen.', options: ['eine Pizza', 'einen Kaffee', 'ein Wasser'], answer: 0 },
    { text: 'Wie ___ die Suppe?', options: ['kostet', 'schmeckt', 'heißt'], answer: 1 },
    { text: 'Guten ___!', options: ['Morgen', 'Appetit', 'Tag'], answer: 1 },
    { text: 'Danke, ___!', options: ['gleichfalls', 'bitte', 'gern'], answer: 0 },
  ]}, schwer: { type: 'gap', instruction: 'Lebensmittel einkaufen.', sentences: [
    { text: 'Ich brauche ein ___ Brot.', options: ['Kilo', 'Stück', 'Liter'], answer: 0 },
    { text: 'Zwei ___ Milch, bitte.', options: ['Kilo', 'Stück', 'Liter'], answer: 2 },
    { text: 'Ein ___ Kuchen, bitte.', options: ['Kilo', 'Stück', 'Liter'], answer: 1 },
    { text: 'Ich habe ___. Ich möchte etwas essen.', options: ['Durst', 'Hunger', 'Spaß'], answer: 1 },
    { text: 'Ich habe ___. Ich möchte etwas trinken.', options: ['Hunger', 'Durst', 'Lust'], answer: 1 },
  ]}}, strukturen: { leicht: { type: 'gap', instruction: 'mögen / möchten — Ergänzen Sie.', sentences: [
    { text: 'Ich ___ einen Kaffee.', options: ['möchte', 'möchtest', 'möchten'], answer: 0 },
    { text: 'Er ___ gern ein Wasser.', options: ['hätte', 'hättest', 'hätten'], answer: 0 },
    { text: '___ du auch etwas essen?', options: ['Möchte', 'Möchtest', 'Möchten'], answer: 1 },
    { text: 'Ich ___ keinen Fisch.', options: ['mag', 'magst', 'mögen'], answer: 0 },
    { text: '___ Sie einen Salat?', options: ['Möchte', 'Möchtest', 'Möchten'], answer: 2 },
  ]}, mittel: { type: 'gap', instruction: 'Akkusativ beim Essen.', sentences: [
    { text: 'Ich nehme ___ Suppe. (f)', options: ['die', 'den', 'das'], answer: 0 },
    { text: 'Er nimmt ___ Salat. (m)', options: ['die', 'den', 'das'], answer: 1 },
    { text: 'Wir bestellen ___ Wasser. (n)', options: ['die', 'den', 'das'], answer: 2 },
    { text: 'Ich möchte ___ Orangensaft.', options: ['eine', 'einen', 'ein'], answer: 1 },
    { text: 'Er isst ___ Brötchen mit Käse.', options: ['eine', 'einen', 'ein'], answer: 2 },
  ]}, schwer: { type: 'order', instruction: 'Bestellungen ordnen.', sentences: [
    { words: ['hätte', 'Ich', 'gern', 'einen', 'Kaffee'], answer: 'Ich hätte gern einen Kaffee' },
    { words: ['möchte', 'Sie', 'eine', 'Suppe'], answer: 'Sie möchte eine Suppe' },
    { words: ['schmeckt', 'Wie', 'der', 'Braten', '?'], answer: 'Wie schmeckt der Braten?' },
    { words: ['möchten', 'Was', 'Sie', 'trinken', '?'], answer: 'Was möchten Sie trinken?' },
  ]}}, kommunikation: { leicht: { type: 'match', instruction: 'Im Restaurant.', pairs: [
    { q: 'Was möchten Sie trinken?', a: 'Einen Kaffee, bitte.' },
    { q: 'Möchten Sie bestellen?', a: 'Ja, ich nehme die Suppe.' },
    { q: 'Hat es Ihnen geschmeckt?', a: 'Ja, sehr gut, danke!' },
    { q: 'Möchten Sie noch etwas?', a: 'Nein, danke. Die Rechnung, bitte.' },
    { q: 'Guten Appetit!', a: 'Danke, gleichfalls!' },
  ]}, mittel: { type: 'gap', instruction: 'Restaurant-Dialog.', sentences: [
    { text: 'Kellner: Was ___ Sie bestellen?', options: ['möchten', 'können', 'müssen'], answer: 0 },
    { text: 'Gast: Ich ___ gern die Suppe.', options: ['hätte', 'habe', 'bin'], answer: 0 },
    { text: 'Kellner: Und zu ___?', options: ['essen', 'trinken', 'bezahlen'], answer: 1 },
    { text: 'Gast: Ein ___, bitte.', options: ['Mineralwasser', 'Kuchen', 'Brot'], answer: 0 },
    { text: 'Kellner: ___, bitte!', options: ['Hier', 'Bitteschön', 'Danke'], answer: 1 },
  ]}, schwer: { type: 'gap', instruction: 'Frühstück besprechen.', sentences: [
    { text: 'Was ___ du gern zum Frühstück?', options: ['trinkst', 'isst', 'kochst'], answer: 1 },
    { text: 'Ich esse gern ___ mit Käse.', options: ['Brötchen', 'Milch', 'Saft'], answer: 0 },
    { text: '___ du gern Tee oder Kaffee?', options: ['Isst', 'Magst', 'Trinkst'], answer: 2 },
    { text: 'Wir ___ zusammen. Das macht Spaß!', options: ['frühstücken', 'kochen', 'kaufen'], answer: 0 },
  ]}}},

  // ──────── LEKTION 10: Ich steige in die U-Bahn ein ────────
  L10: { title: 'Lektion 10: Ich steige jetzt in die U-Bahn ein.', worter: { leicht: { type: 'sort', instruction: 'Verkehrsmittel sortieren.', categories: ['Öffentlich / Public', 'Privat / Private'], items: [
    { word: 'die U-Bahn', cat: 0 }, { word: 'der Bus', cat: 0 }, { word: 'die Straßenbahn', cat: 0 },
    { word: 'die S-Bahn', cat: 0 }, { word: 'der Zug', cat: 0 },
    { word: 'das Auto', cat: 1 }, { word: 'das Fahrrad', cat: 1 }, { word: 'zu Fuß', cat: 1 },
    { word: 'das Taxi', cat: 1 }, { word: 'das Flugzeug', cat: 1 },
  ]}, mittel: { type: 'gap', instruction: 'Am Bahnhof / Flughafen.', sentences: [
    { text: 'Der Zug fährt auf ___ 15 ab.', options: ['Haltestelle', 'Gleis', 'Bahnsteig'], answer: 1 },
    { text: 'Wann ___ der Zug an?', options: ['fährt', 'kommt', 'steigt'], answer: 1 },
    { text: 'Ich habe zwei ___.', options: ['Gepäck', 'Koffer', 'Gleis'], answer: 1 },
    { text: 'Der nächste ___ heißt Mönckebergstraße.', options: ['Halt', 'Zug', 'Bus'], answer: 0 },
    { text: 'Einmal München, ___ und zurück.', options: ['hin', 'ab', 'an'], answer: 0 },
  ]}, schwer: { type: 'gap', instruction: 'Wegbeschreibung.', sentences: [
    { text: 'Gehen Sie ___ und dann links.', options: ['geradeaus', 'zurück', 'rechts'], answer: 0 },
    { text: 'Die Apotheke ist ___ der Ecke.', options: ['in', 'an', 'auf'], answer: 1 },
    { text: 'Nehmen Sie die ___ Straße rechts.', options: ['erste', 'ein', 'eine'], answer: 0 },
    { text: 'Entschuldigung, ich habe mich ___.', options: ['gefunden', 'verlaufen', 'gefahren'], answer: 1 },
  ]}}, strukturen: { leicht: { type: 'gap', instruction: 'Trennbare Verben: ein-/aus-/um-steigen.', sentences: [
    { text: 'Ich steige in die U-Bahn ___. (einsteigen)', options: ['aus', 'ein', 'um'], answer: 1 },
    { text: 'Bitte steigen Sie hier ___. (aussteigen)', options: ['aus', 'ein', 'um'], answer: 0 },
    { text: 'Wir steigen in Linie 3 ___. (umsteigen)', options: ['aus', 'ein', 'um'], answer: 2 },
    { text: 'Der Zug fährt um 8:30 ___. (abfahren)', options: ['an', 'ab', 'ein'], answer: 1 },
    { text: 'Frau Alvarez kommt um 17:35 ___. (ankommen)', options: ['an', 'ab', 'ein'], answer: 0 },
    { text: 'Ich hole dich am Bahnhof ___. (abholen)', options: ['an', 'ab', 'ein'], answer: 1 },
  ]}, mittel: { type: 'gap', instruction: 'Trennbar oder nicht trennbar?', sentences: [
    { text: 'Wir sehen heute Abend ___. (fernsehen)', options: ['fern', 'an', 'ein'], answer: 0 },
    { text: 'Ich bringe einen Kuchen ___. (mitbringen)', options: ['an', 'mit', 'ab'], answer: 1 },
    { text: 'Wann ___ du mit Oma? (telefonieren)', options: ['telefonierst', 'rufst an', 'siehst'], answer: 0 },
    { text: 'Er ___ am Samstag seine Freundin. (besuchen)', options: ['besucht', 'holt ab', 'kauft ein'], answer: 0 },
  ]}, schwer: { type: 'order', instruction: 'Sätze mit trennbaren Verben ordnen.', sentences: [
    { words: ['Sie', 'Gehen', 'geradeaus', 'und', 'dann', 'links'], answer: 'Gehen Sie geradeaus und dann links' },
    { words: ['steige', 'Ich', 'in', 'die', 'U-Bahn', 'ein'], answer: 'Ich steige in die U-Bahn ein' },
    { words: ['fährt', 'Der', 'Zug', 'um', '8:30', 'ab'], answer: 'Der Zug fährt um 8:30 ab' },
    { words: ['hole', 'Ich', 'dich', 'am', 'Bahnhof', 'ab'], answer: 'Ich hole dich am Bahnhof ab' },
  ]}}, kommunikation: { leicht: { type: 'match', instruction: 'Am Bahnhof / Nach dem Weg fragen.', pairs: [
    { q: 'Wie komme ich zum Bahnhof?', a: 'Gehen Sie geradeaus und dann rechts.' },
    { q: 'Wo ist die nächste Apotheke?', a: 'An der Ecke, links.' },
    { q: 'Fährt der Bus zum Krankenhaus?', a: 'Ja, Linie 5.' },
    { q: 'Wo fährt der Zug nach Köln ab?', a: 'Auf Gleis 15.' },
    { q: 'Wann kommst du an?', a: 'Um 20:50 Uhr am Ostbahnhof.' },
  ]}, mittel: { type: 'gap', instruction: 'Reiseplanung.', sentences: [
    { text: 'Ich brauche eine ___ nach Berlin.', options: ['Fahrkarte', 'Straße', 'Haltestelle'], answer: 0 },
    { text: '___ und zurück, bitte.', options: ['Hin', 'Ab', 'An'], answer: 0 },
    { text: '___ du den Zug oder das Flugzeug?', options: ['Steigst', 'Fährst', 'Nimmst'], answer: 2 },
    { text: 'Holst du mich am Flughafen ___?', options: ['an', 'ab', 'ein'], answer: 1 },
  ]}, schwer: { type: 'gap', instruction: 'Durchsagen am Bahnhof.', sentences: [
    { text: 'Vorsicht an der ___!', options: ['Haltestelle', 'Bahnsteigkante', 'Straße'], answer: 1 },
    { text: 'Die Passagiere von Flug 134 können jetzt ___.', options: ['aussteigen', 'einsteigen', 'umsteigen'], answer: 1 },
    { text: 'Der ICE 756 aus Hamburg kommt um 13:27 Uhr ___.', options: ['ab', 'an', 'ein'], answer: 1 },
  ]}}},

  // ──────── LEKTION 11: Was hast du heute gemacht? ────────
  L11: { title: 'Lektion 11: Was hast du heute gemacht?', worter: { leicht: { type: 'sort', instruction: 'Perfekt: haben oder sein?', categories: ['mit „haben"', 'mit „sein"'], items: [
    { word: 'gekocht', cat: 0 }, { word: 'gegessen', cat: 0 }, { word: 'gearbeitet', cat: 0 },
    { word: 'gelernt', cat: 0 }, { word: 'gelesen', cat: 0 }, { word: 'eingekauft', cat: 0 },
    { word: 'gefahren', cat: 1 }, { word: 'gegangen', cat: 1 }, { word: 'gekommen', cat: 1 },
    { word: 'geflogen', cat: 1 }, { word: 'geschwommen', cat: 1 }, { word: 'aufgestanden', cat: 1 },
  ]}, mittel: { type: 'gap', instruction: 'Perfekt bilden: Was haben Sie gemacht?', sentences: [
    { text: 'Ich habe gestern viel ___. (arbeiten)', options: ['gearbeitet', 'arbeiten', 'arbeitet'], answer: 0 },
    { text: 'Sie ist nach Berlin ___. (fahren)', options: ['gefahren', 'fahren', 'fährt'], answer: 0 },
    { text: 'Wir haben Pizza ___. (essen)', options: ['gegessen', 'essen', 'isst'], answer: 0 },
    { text: 'Er hat Deutsch ___. (lernen)', options: ['gelernt', 'lernen', 'lernt'], answer: 0 },
    { text: 'Ich habe die Zeitung ___. (lesen)', options: ['gelesen', 'lesen', 'liest'], answer: 0 },
    { text: 'Sie hat einen Kuchen ___. (backen)', options: ['gebacken', 'backen', 'bäckt'], answer: 0 },
  ]}, schwer: { type: 'gap', instruction: 'Tagesablauf im Perfekt erzählen.', sentences: [
    { text: 'Ich bin um 7 Uhr ___. (aufstehen)', options: ['aufgestanden', 'aufstehen', 'aufsteht'], answer: 0 },
    { text: 'Dann habe ich ___. (frühstücken)', options: ['gefrühstückt', 'frühstücke', 'frühstückt'], answer: 0 },
    { text: 'Am Nachmittag habe ich ___. (einkaufen)', options: ['eingekauft', 'einkaufen', 'kaufe ein'], answer: 0 },
    { text: 'Am Abend bin ich ins Kino ___. (gehen)', options: ['gegangen', 'gehen', 'geht'], answer: 0 },
    { text: 'Gestern haben meine Freunde und ich lange ___. (feiern)', options: ['gefeiert', 'feiern', 'feiert'], answer: 0 },
  ]}}, strukturen: { leicht: { type: 'gap', instruction: 'haben/sein + Partizip II — Was passt?', sentences: [
    { text: 'Ich ___ Deutsch gelernt.', options: ['habe', 'bin', 'hat'], answer: 0 },
    { text: 'Er ___ nach Hause gegangen.', options: ['hat', 'ist', 'bin'], answer: 1 },
    { text: 'Wir ___ lange geschlafen.', options: ['sind', 'haben', 'hat'], answer: 1 },
    { text: 'Sie ___ nach Berlin geflogen.', options: ['hat', 'ist', 'haben'], answer: 1 },
    { text: 'Ich ___ meine Freunde eingeladen.', options: ['bin', 'habe', 'ist'], answer: 1 },
    { text: 'Er ___ viel Wein getrunken.', options: ['ist', 'hat', 'sind'], answer: 1 },
  ]}, mittel: { type: 'gap', instruction: 'Temporale Ausdrücke: um/am/von...bis/ab.', sentences: [
    { text: 'Lisa frühstückt ___ 7 Uhr.', options: ['am', 'um', 'von'], answer: 1 },
    { text: '___ 8 Uhr arbeitet sie.', options: ['Um', 'Am', 'Ab'], answer: 2 },
    { text: 'Sie arbeitet ___ 8 ___ 18 Uhr.', options: ['am...um', 'von...bis', 'um...am'], answer: 1 },
    { text: '___ Abend geht sie ins Kino.', options: ['Um', 'Am', 'Von'], answer: 1 },
    { text: '___ Montag frühstückt Lisa um 7 Uhr.', options: ['Um', 'Am', 'Von'], answer: 1 },
  ]}, schwer: { type: 'order', instruction: 'Perfekt-Sätze bilden.', sentences: [
    { words: ['habe', 'Ich', 'gestern', 'gekocht'], answer: 'Ich habe gestern gekocht' },
    { words: ['ist', 'Sie', 'nach', 'Berlin', 'gefahren'], answer: 'Sie ist nach Berlin gefahren' },
    { words: ['hat', 'Er', 'die', 'Zeitung', 'gelesen'], answer: 'Er hat die Zeitung gelesen' },
    { words: ['habe', 'Ich', 'Freunde', 'eingeladen'], answer: 'Ich habe Freunde eingeladen' },
    { words: ['sind', 'Wir', 'ins', 'Kino', 'gegangen'], answer: 'Wir sind ins Kino gegangen' },
  ]}}, kommunikation: { leicht: { type: 'match', instruction: 'Über den Tag / das Wochenende sprechen.', pairs: [
    { q: 'Was hast du heute gemacht?', a: 'Ich habe gearbeitet und eingekauft.' },
    { q: 'Bist du heute gelaufen?', a: 'Ja, 5 Kilometer!' },
    { q: 'Habt ihr gestern gekocht?', a: 'Ja, wir haben Pizza gemacht.' },
    { q: 'Hast du heute arbeitet?', a: 'Ja, aber nur bis 14 Uhr.' },
    { q: 'Hast du Monika gesehen?', a: 'Ja, letzte Woche.' },
  ]}, mittel: { type: 'gap', instruction: 'Wochenende und Urlaub erzählen.', sentences: [
    { text: 'Am Samstag ___ ich ins Kino gegangen.', options: ['habe', 'bin', 'hat'], answer: 1 },
    { text: 'Wir haben zusammen ___.', options: ['gegessen', 'essen', 'isst'], answer: 0 },
    { text: 'Wir sind nach Spanien ___. (fly)', options: ['geflogen', 'gefahren', 'gegangen'], answer: 0 },
    { text: 'Dort haben wir viel ___. (swim)', options: ['geschwommen', 'gelaufen', 'gegessen'], answer: 0 },
    { text: 'Gestern haben wir lange ___. (celebrate)', options: ['gefeiert', 'gearbeitet', 'geschlafen'], answer: 0 },
  ]}, schwer: { type: 'gap', instruction: 'E-Mail im Perfekt schreiben.', sentences: [
    { text: 'Ich habe im Mai bei einer neuen Firma ___.', options: ['gearbeitet', 'angefangen', 'gewohnt'], answer: 1 },
    { text: 'Meine Kollegen sind sehr nett. Wir haben viel ___.', options: ['gelacht', 'gearbeitet', 'geschlafen'], answer: 0 },
    { text: 'Ich habe auch ein neues Fahrrad ___.', options: ['gefahren', 'gekauft', 'gefunden'], answer: 1 },
    { text: 'Hast du schon lange nicht ___?', options: ['geschlafen', 'geschrieben', 'gegessen'], answer: 1 },
  ]}}},

  // ──────── LEKTION 12: Was ist denn hier passiert? ────────
  L12: { title: 'Lektion 12: Was ist denn hier passiert?', worter: { leicht: { type: 'sort', instruction: 'Körperteile sortieren.', categories: ['Kopf / Head', 'Körper / Body', 'Arm/Bein / Limbs'], items: [
    { word: 'der Kopf', cat: 0 }, { word: 'das Auge', cat: 0 }, { word: 'die Nase', cat: 0 },
    { word: 'der Mund', cat: 0 },
    { word: 'der Bauch', cat: 1 }, { word: 'der Rücken', cat: 1 },
    { word: 'der Arm', cat: 2 }, { word: 'das Bein', cat: 2 }, { word: 'die Hand', cat: 2 },
    { word: 'der Fuß', cat: 2 },
  ]}, mittel: { type: 'gap', instruction: 'Beim Arzt — Gesundheit.', sentences: [
    { text: 'Ich habe ___. (headache)', options: ['Kopfschmerzen', 'Bauchschmerzen', 'Fieber'], answer: 0 },
    { text: 'Mir ist ___. (nauseous)', options: ['kalt', 'schlecht', 'warm'], answer: 1 },
    { text: 'Er hat sich das Bein ___. (broken)', options: ['gewaschen', 'verletzt', 'gebrochen'], answer: 2 },
    { text: 'Was ist ___? (happened)', options: ['gekommen', 'passiert', 'gegangen'], answer: 1 },
    { text: 'Nehmen Sie die ___ dreimal täglich.', options: ['Suppe', 'Tabletten', 'Salbe'], answer: 1 },
  ]}, schwer: { type: 'gap', instruction: 'Monate und Jahreszeiten.', sentences: [
    { text: 'Der ___ ist der erste Monat im Jahr.', options: ['März', 'Januar', 'Juli'], answer: 1 },
    { text: 'Im ___ beginnt der Frühling.', options: ['Januar', 'März', 'September'], answer: 1 },
    { text: 'Juni, Juli und August ist ___.', options: ['Winter', 'Frühling', 'Sommer'], answer: 2 },
    { text: 'Im ___ feiert man Weihnachten.', options: ['Oktober', 'November', 'Dezember'], answer: 2 },
    { text: 'September, Oktober, November ist ___.', options: ['Herbst', 'Sommer', 'Winter'], answer: 0 },
  ]}}, strukturen: { leicht: { type: 'gap', instruction: 'Perfekt mit sein: war / hatte.', sentences: [
    { text: 'Er hat sich den Arm ___. (brechen)', options: ['gebrochen', 'gebrechen', 'bricht'], answer: 0 },
    { text: 'Was ist hier ___? (passieren)', options: ['passieren', 'passiert', 'passt'], answer: 1 },
    { text: 'Sie ist vom Fahrrad ___. (fallen)', options: ['gefallen', 'gefallt', 'fällt'], answer: 0 },
    { text: 'Marc ___ nach New York geflogen.', options: ['hat', 'ist', 'war'], answer: 1 },
    { text: 'Ich ___ am Montag nicht in den Kurs gekommen.', options: ['habe', 'bin', 'war'], answer: 1 },
  ]}, mittel: { type: 'gap', instruction: 'war / hatte — Ergänzen Sie.', sentences: [
    { text: 'Ich ___ gestern im Kino. (was)', options: ['war', 'hatte', 'bin'], answer: 0 },
    { text: 'Ich ___ kein Geld. (had)', options: ['war', 'hatte', 'bin'], answer: 1 },
    { text: 'Wie ___ der Film? – Langweilig!', options: ['hatte', 'war', 'ist'], answer: 1 },
    { text: 'Wie ___ die Party? – Ich ___ viel Spaß.', options: ['war...hatte', 'hatte...war', 'ist...hat'], answer: 0 },
    { text: 'Portugal ___ wirklich super!', options: ['hatte', 'war', 'ist'], answer: 1 },
  ]}, schwer: { type: 'order', instruction: 'Unfallbericht / Arztbesuch ordnen.', sentences: [
    { words: ['ist', 'Was', 'denn', 'hier', 'passiert', '?'], answer: 'Was ist denn hier passiert?' },
    { words: ['habe', 'Ich', 'mich', 'verletzt'], answer: 'Ich habe mich verletzt' },
    { words: ['bin', 'Ich', 'vom', 'Fahrrad', 'gefallen'], answer: 'Ich bin vom Fahrrad gefallen' },
    { words: ['hat', 'Er', 'sich', 'den', 'Arm', 'gebrochen'], answer: 'Er hat sich den Arm gebrochen' },
  ]}}, kommunikation: { leicht: { type: 'match', instruction: 'Arztbesuch.', pairs: [
    { q: 'Was fehlt Ihnen?', a: 'Ich habe Kopfschmerzen und Fieber.' },
    { q: 'Tut das weh?', a: 'Ja, sehr!' },
    { q: 'Nehmen Sie Medikamente?', a: 'Nein, noch nicht.' },
    { q: 'Seit wann haben Sie die Schmerzen?', a: 'Seit drei Tagen.' },
    { q: 'Was ist passiert?', a: 'Ich bin vom Fahrrad gefallen.' },
  ]}, mittel: { type: 'gap', instruction: 'Arzt-Gespräch.', sentences: [
    { text: 'Arzt: Was ___ Ihnen?', options: ['ist', 'fehlt', 'hat'], answer: 1 },
    { text: 'Patient: Mir tut der ___ weh.', options: ['Rücken', 'Hunger', 'Schlaf'], answer: 0 },
    { text: 'Arzt: Nehmen Sie diese ___ dreimal täglich.', options: ['Wasser', 'Tabletten', 'Suppe'], answer: 1 },
    { text: 'Patient: Ich habe mich ___.', options: ['gefreut', 'verletzt', 'gefragt'], answer: 1 },
    { text: 'Arzt: Hast du ___ wehgetan?', options: ['mich', 'dich', 'sich'], answer: 1 },
  ]}, schwer: { type: 'gap', instruction: 'Urlaubserlebnisse erzählen.', sentences: [
    { text: 'Ich bin viel im Atlantik ___.', options: ['gefahren', 'geschwommen', 'gelaufen'], answer: 1 },
    { text: 'Leider war die Fahrt sehr ___.', options: ['kurz', 'lang', 'schön'], answer: 1 },
    { text: 'Ich bin dreimal ___.', options: ['umgestiegen', 'eingestiegen', 'ausgestiegen'], answer: 0 },
    { text: 'Nächste Woche ___ wir!', options: ['arbeiten', 'feiern', 'schlafen'], answer: 1 },
  ]}}},
};

export default EXERCISES;
